'use client'
import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'

interface Topic {
    id: number
    name: string
}

interface Props {
    labelText: string
    list: Topic[]
    setOption: (key, value) => void
    isOpen: boolean
    selectedOption: string
    stateKey: string
    setState: (key, value) => void
    toggleState: (key) => void
    className?: string
}

const ForPartnersSelect: React.FC<Props> = ({
    labelText,
    list,
    setOption,
    isOpen,
    stateKey,
    selectedOption,
    setState,
    toggleState,
    className
}) => {
    // const pathname = usePathname()
    // const isCatalog = pathname.includes('/catalog')
    const selectRef = useRef<HTMLDivElement>(null)
    const isDefault = selectedOption === list[0].name

    const toggleOptions = () => {
        toggleState(stateKey)
    }

    const changeOption = option => {
        setOption(stateKey, option)
        setState(stateKey, false)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                selectRef.current &&
                !event.composedPath().includes(selectRef.current) &&
                selectRef.current.classList.contains('for-partners__select_open')
            ) {
                setState(stateKey, false)
            }
        }

        document.body.addEventListener('click', handleClickOutside)
        return () => document.body.removeEventListener('click', handleClickOutside)
    }, [])

    return (
        <div
            className={classNames(
                'for-partners__input-block',
                isOpen && 'for-partners__input-block_focused',
                className
            )}
        >
            <p className='for-partners__label-text'>{labelText}</p>
            <div
                ref={selectRef}
                className={`for-partners__select ${isOpen && 'for-partners__select_open'}`}
            >
                <div
                    onClick={toggleOptions}
                    className={`for-partners__select-btn ${isOpen && 'for-partners__select-btn_active'} ${
                        isDefault && 'for-partners__select-btn_default'
                    }`}
                >
                    <p>{selectedOption}</p>
                    <svg
                        style={isOpen ? { transform: 'rotate(180deg)' } : {}}
                        width='40'
                        height='40'
                        viewBox='0 0 40 40'
                        fill='none'
                    >
                        <path
                            d='M10 16L19.9366 24.1531C19.9734 24.1833 20.0266 24.1833 20.0634 24.1531L30 16'
                            stroke='#A9B4D1'
                            strokeWidth='3'
                            strokeLinecap='round'
                        />
                    </svg>
                </div>
                <div className='for-partners__select-list-wrapper'>
                    <ul className={`for-partners__select-list ${isOpen && 'for-partners__select-list_open'}`}>
                        {/* <li className="for-partners__select-list-overlay"></li> */}
                        {list?.map(item => (
                            <li
                                onClick={() => changeOption(item.name)}
                                key={item.id}
                                className={
                                    selectedOption.toLowerCase() === item.name.toLowerCase()
                                        ? 'for-partners__select-option for-partners__select-option_selected'
                                        : 'for-partners__select-option'
                                }
                                value={item.name}
                            >
                                {item.name}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ForPartnersSelect
